import { softValidateResponse } from "@/server/validation";
import { instance } from "../api-instance";
import { GetOfferInfoTextResponseSchema } from "./schemas";

export const OfferApi = {
  getOfferInfoText({
    applicationId,
    offerSum,
  }: {
    applicationId: string;
    offerSum?: number;
  }) {
    return instance
      .get(
        `offer/getOfferInfoText?applicationId=${applicationId}` +
          (offerSum ? `&offerSum=${offerSum}` : "")
      )
      .then(softValidateResponse(GetOfferInfoTextResponseSchema))
      .then((res) => res.data);
  },

  getIsTimerPageEnabled(): Promise<unknown> {
    return instance.get("offer/isTimerPageEnabled").then((res) => res.data);
  },

  saveAndSend({
    codeId,
    code,
    applicationId,
    cookie,
  }: {
    codeId: string;
    code: string;
    applicationId: string;
    cookie: string;
  }): Promise<unknown> {
    return instance.post("offer/savePaymentOfferAndSendToConsideration", {
      codeId,
      code,
      applicationId,
      cookie,
    });
  },

  saveAndWaitForScans({
    codeId,
    code,
    applicationId,
    cookie,
  }: {
    codeId: string;
    code: string;
    applicationId: string;
    cookie: string;
  }): Promise<unknown> {
    return instance.post("offer/SavePaymentOfferAndWaitForScans", {
      codeId,
      code,
      applicationId,
      cookie,
    });
  },

  getDecisionApplication(id: unknown): Promise<unknown> {
    return instance
      .post("offer/checkDecisionApplication", id)
      .then((res) => res.data);
  },
};
